<template>
  <main-layout>

    <!-- 左メニュー -->
    <div slot="left-side">
      <menubar screenIdParam="M-06-46"></menubar>
    </div>

    <!-- ヘッダー行 -->
    <el-row slot="header">
      <head-title class="cancel-width">
        <!--  TODO: i18n  -->
        <label slot="title">環境可視化</label>
        <!--  TODO: auth code  -->
        <!--  TODO: i18n  -->
        <narrow-down
          @click="toCreateVisualPage"
          v-auth="{ auth: '060402' }"
          slot="create">
          環境可視化ページを追加
        </narrow-down>
      </head-title>
    </el-row>

    <!-- メインページ -->
    <div slot="body">

      <!--   検索エリア開始   -->
      <div class="panel-search">
        <el-form :model="query" :rules="rules" class="search-form" ref="ruleForm">

          <!-- オーナー -->
          <div class="fm-row">
            <el-form-item
              prop="ownerExId">
              <el-input
                maxlength="20"
                class="fm-input"
                v-model="query.ownerExId"
                :placeholder="$t('label.common.ownerIdPlaceHolder')">
              </el-input>
            </el-form-item>
            <sp-smart-label-button class="fm-lb-btn line-limit-length" v-show="query.ownerName">
              {{ query.ownerName }}
            </sp-smart-label-button>
            <button-index @click="selectOwner" class="fm-st-btn limit-length">
              {{$t("button.common.select")}}
            </button-index>
          </div>
          <!-- ビル -->
          <div class="fm-row">
            <el-form-item
              prop="buildingExId">
              <el-input
                maxlength="20"
                class="fm-input"
                v-model="query.buildingExId"
                :placeholder="$t('label.common.buildingIdPlaceHolder')">
              </el-input>
            </el-form-item>
            <sp-smart-label-button class="fm-lb-btn line-limit-length" v-show="query.buildingName">
              {{ query.buildingName }}
            </sp-smart-label-button>
            <button-index @click="selectBuilding" class="fm-st-btn limit-length">
              {{$t("button.common.select")}}
            </button-index>
          </div>
          <!-- フロア -->
          <div class="fm-row">
            <el-form-item>
              <el-input
                :readonly="true"
                clearable
                maxlength="50"
                class="fm-input"
                v-model="query.floorName"
                :placeholder="$t('label.system.meetingRoom.search.query.floorSelect')"
              >
              </el-input>
            </el-form-item>
            <button-index @click="selectFloor" class="fm-st-btn limit-length">
              {{$t("button.common.select") }}
            </button-index>
          </div>
          <!-- エリア名 -->
          <div class="fm-row">
            <el-form-item>
              <el-input
                :readonly="true"
                clearable
                maxlength="50"
                class="fm-input"
                v-model="query.areaName"
                :placeholder="$t('label.system.meetingRoom.search.query.areaSelect')"
              >
              </el-input>
            </el-form-item>
            <button-index @click="selectArea" class="fm-st-btn limit-length">
              {{$t("button.common.select") }}
            </button-index>
          </div>

          <!-- 環境可視化ページ名 -->
          <div class="fm-row">
            <el-form-item size="small" prop="pageName">
              <el-input maxlength="50"
                v-model="query.pageName"
                class="fm-input"
                :placeholder="'環境可視化ページ名（部分一致）'"
              ></el-input>
            </el-form-item>
            <el-checkbox v-model="query.pageAreaOnlyFlag" class="m-top-1" label="1">環境可視化ページ登録済みエリアのみ表示</el-checkbox>
          </div>

          <!--  検索ボタン  -->
          <div class="btn-area fm-row">
            <narrow-down
              @click="handleClickSearch"
            >
              {{$t("button.common.narrow")}}
            </narrow-down>
            <cancel-narrow-down
              class="link-primary margin-left-8"
              @click="clearSearchParams"
            >
              {{$t('button.system.building.search.clear')}}
            </cancel-narrow-down>
          </div>
        </el-form>
      </div>

      <el-row class="margin-top-28" ref="searchResultTable">
        <div>
          <visual-page-search-result
            v-show="showSearchResult"
            :result="searchResult"
            :show-loading="showTableLoading"
            @up="sortUp"
            @down="sortDown"
            @on-paging="handlePaging"
            @on-detail="handleDetail"
            @on-delete="handleDelete"
          />
        </div>
      </el-row>

      <!-- オーナー選択子画面 -->
      <owner-search-popup
        :ownerExIdParam="query.ownerExId"
        :ownerNameParam="query.ownerName"
        :ownerId="query.ownerExId"
        :visible.sync="ownerSearchFlg"
        @on-selected="getOwnerInfo"
      />

      <!-- ビル選択子画面 -->
      <building-search-popup
        :ownerIdParam="query.ownerId"
        :buildingExIdParam="query.buildingExId"
        :buildingNameParam="query.buildingName"
        :visible.sync="buildingSearchFlg"
        @on-selected="getBuildingInfo"
      />

      <!-- フロア選択子画面 -->
      <floor-search-popup
        :ownerIdParam="query.ownerId"
        :buildingIdParam="query.buildingId"
        :floorNameParam="query.floorName"
        :visible.sync="floorSearchFlg"
        @on-selected="getFloorInfo"
      />

      <!-- エリア選択子画面 -->
      <area-search-popup
        :ownerIdParam="query.ownerId"
        :buildingIdParam="query.buildingId"
        :floorIdParam="query.floorId"
        :areaNameParam="query.areaName"
        :visible.sync="areaSearchFlg"
        @on-selected="getAreaInfo"
      />

    </div>

  </main-layout>
</template>

<script>
import MainLayout from "@/layout/NewDesignLayout";
import Menubar from "@/components/leftmenu/DashBoard"
import HeadTitle from "@/components/common/head/head";
import ButtonIndex from "@/components/common/sp-smart-button/index";
import SpSmartLabelButton from "@/components/common/sp-smart-lable-button"
import NarrowDown from "@/components/common/generalButton/NarrowDown";
import CancelNarrowDown from "@/components/common/generalButton/CancelNarrowDown";
import OwnerSearchPopup from "@/components/system/popup/OwnerSearchPopup";
import BuildingSearchPopup from "@/components/system/popup/BuildingSearchPopup";
import FloorSearchPopup from "@/components/system/popup/FloorSearchPopup";
import AreaSearchPopup from "@/components/system/popup/AreaSearchPopup";
import VisualPageSearchResult from "@/views/visual-env/page/search/SearchResult";
import PageSearchRuleFactory from "@/rules/rule-page-search"
import api from "@/api/SystemManageApi";
import {nextId} from "@/views/visual-env/utils";
import errorCodeMsg from "@/utils/error-code-msg";
import statusErrorCodeMsg from "@/utils/status-error-msg";

const QUERY_SAVE_KEY = "visual-env-page-search-query";

export default {
  name: "VisualPageSearch",
  components: {
    VisualPageSearchResult,
    AreaSearchPopup,
    FloorSearchPopup,
    BuildingSearchPopup,
    OwnerSearchPopup,
    CancelNarrowDown, NarrowDown, Menubar, MainLayout, HeadTitle, ButtonIndex, SpSmartLabelButton },
  data() {
    return {
      ownerSearchFlg: false,
      buildingSearchFlg: false,
      floorSearchFlg: false,
      areaSearchFlg: false,
      query: {
        ownerId: null,
        ownerExId: null,
        ownerName: null,
        buildingId: null,
        buildingExId: null,
        buildingName: null,
        floorId: null,
        floorName: null,
        areaId: null,
        areaName: null,
        pageName: null,
        pageSize: 10,
        pageNumber: 1,
        pageAreaOnlyFlag: true
      },
      rules: PageSearchRuleFactory.searchRules(this),
      area: false,
      searchResult: {
        totalCount: 0,
        totalPage: 0,
        pageSize: 10,
        pageNumber: 1,
        body: []
      },
      showSearchResult: false,
      showTableLoading: false
    }
  },
  created() {
    // TODO: what is bread path?
    let breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/setting/various",
        title: "label.router.set",
      },
      {
        path: "/visual-env/page/search",
        // TODO: i18n
        title: "環境可視化",
      }
    ];
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb);
    this.$authCheck("060401");
  },
  methods: {
    toCreateVisualPage() {
      this.$router.push({ name: "page-create" });
    },

    handlePaging(paging) {
      this.query.pageNumber = paging.pageNumber;
      this.query.pageSize = paging.pageSize;
      this.doneSearch();
    },

    handleDetail(pageId) {
      this.$router.push({ name: "page-create", query: { pageId: pageId } });
    },

    handleDelete(pageId) {
      this.showTableLoadingAnim();
      api.deviceEnvViewPageDelete(pageId)
        .then(({ data }) => {
          if (!statusErrorCodeMsg(data.statusCode, this)) {
            return;
          }
          this.doneSearch();
        })
        .catch(error => {
          errorCodeMsg(error, this)
        })
        .finally(() => {
          this.hideTableLoadingAnim();
        });
    },

    showTableLoadingAnim() {
      this.showTableLoading = true;
    },

    hideTableLoadingAnim() {
      this.showTableLoading = false;
    },

    handleClickSearch() {
      this.query.pageNumber = 1;
      this.query.pageSize = 10;
      this.doneSearch();
    },

    doneSearch() {
      this.$refs.ruleForm.validate((success) => {
        if (success) {
          this.showSearchResult = true;
          this.showTableLoadingAnim();

          this.$saveQueryParam(QUERY_SAVE_KEY, this.query);

          api.deviceEnvViewPageSearch(this.query)
            .then(({ data }) => {

              const { body } = data;
              if (!statusErrorCodeMsg(data.statusCode, this)) {
                return;
              }
              this.searchResult = {
                totalCount: body.totalCount,
                totalPage: body.totalPage,
                pageSize: body.pageSize,
                pageNumber: body.pageNumber,
                body: body.body.flatMap(area => {
                  let pageList = [];
                  const basic = {
                    ownerId: area.ownerId,
                    ownerName: area.ownerName,
                    ownerExId: area.ownerExId,
                    buildingId: area.buildingId,
                    buildingName: area.buildingName,
                    buildingExId: area.buildingExId,
                    floorId: area.floorId,
                    floorName: area.floorName,
                    areaId: area.areaId,
                    areaName: area.areaName
                  };
                  if (area.pageList.length === 0) {
                    pageList.push({
                      ...basic,
                      pageId: 'dummy_' + nextId(),
                      pageName: '-',
                      iconCode: '-',
                      availableFlag: '-',
                      deleteFlag: false,
                      displayOrder: '-',
                      publishAreaList: []
                    });
                  } else {
                    for (let page of area.pageList) {
                      pageList.push({
                        ...basic,
                        ...page
                      });
                    }
                  }
                  return pageList;
                })
              };
            })
            .catch((error) => {
              errorCodeMsg(error, this)
            })
            .finally(() => {
              this.hideTableLoadingAnim();
            });
        }
      });
    },

    // オーナー選択
    selectOwner() {
      this.ownerSearchFlg = true;
    },
    // ビル選択
    selectBuilding() {
      this.buildingSearchFlg = true;
    },
    // フロア選択
    selectFloor() {
      this.floorSearchFlg = true;
    },
    // エリア選択
    selectArea() {
      this.areaSearchFlg = true;
    },

    // オーナー選択-子组件
    getOwnerInfo: function (owner) {
      if (this.query.ownerId !== owner.id) {
        this.query.buildingId = null;
        this.query.buildingExId = null;
        this.query.buildingName = null;
        this.query.floorId = null;
        this.query.floorName = null;
        this.query.areaId = null;
        this.query.areaName = null;
      }
      this.query.ownerId = owner.id;
      this.query.ownerName = owner.name;
      this.query.ownerExId = owner.exId;
    },
    // 获取 ビル選択 子画面的值
    getBuildingInfo(building) {
      if (this.query.buildingId !== building.buildingId) {
        this.query.floorId = null;
        this.query.floorName = null;
        this.query.areaId = null;
        this.query.areaName = null;
      }
      this.query.ownerId = building.ownerId;
      this.query.ownerExId = building.ownerExId;
      this.query.ownerName = building.ownerName;
      this.query.buildingId = building.buildingId;
      this.query.buildingExId = building.buildingExId;
      this.query.buildingName = building.buildingName;
    },
    // 获取 フロア選択子画面的值
    getFloorInfo(floor) {
      if (this.query.floorId !== floor.floorId) {
        this.query.areaId = null;
        this.query.areaName = null;
      }
      this.query.ownerId = floor.ownerId;
      this.query.ownerName = floor.ownerName;
      this.query.ownerExId = floor.ownerExId;
      this.query.buildingName = floor.buildingName;
      this.query.buildingExId = floor.buildingExId;
      this.query.buildingId = floor.buildingId;
      this.query.floorName = floor.floorName;
      this.query.floorId = floor.floorId;
    },
    // 获取 エリア選択子画面的值
    getAreaInfo(area) {
      this.query.ownerId = area.ownerId;
      this.query.ownerExId = area.ownerExId;
      this.query.ownerName = area.ownerName;
      this.query.buildingId = area.buildingId;
      this.query.buildingExId = area.buildingExId;
      this.query.buildingName = area.buildingName;
      this.query.floorId = area.floorId;
      this.query.floorName = area.floorName;
      this.query.areaId = area.areaId;
      this.query.areaName = area.areaName;
    },
    // クリア
    clearSearchParams() {
      this.$saveQueryParam(QUERY_SAVE_KEY, null)
      this.query.ownerId = null
      this.query.ownerExId = null
      this.query.ownerName = null
      this.query.buildingId = null
      this.query.buildingExId = null
      this.query.buildingName = null
      this.query.floorId = null
      this.query.floorName = null
      this.query.areaId = null
      this.query.areaName = null
      this.query.pageName = null
      this.query.meetingRoomName = null
      // (this.query.pageSize = DEFAULT_PAGE_SIZE),
      // (this.query.pageNumber = DEFAULT_PAGE_NUMBER),
      this.query.totalCount = 0
      this.searchResult.totalPage = 0
      this.searchResult.totalCount = 0
      this.searchResult.body = []
      this.isShow = false
      this.showSearchResult = false;
      this.$refs["ruleForm"].resetFields();
    },
    sortUp(pageId) {
      const index = this.searchResult.body.findIndex((page) => pageId === page.pageId);
      if (index > 0) {
        this.exchange(index, index - 1);
      }
    },
    sortDown(pageId) {
      const index = this.searchResult.body.findIndex((page) => pageId === page.pageId);
      if (index >= 0 && index < this.searchResult.body.length - 1) {
        this.exchange(index, index + 1);
      }
    },
    exchange(index1, index2) {
      let page1 = this.searchResult.body[index1];
      let page2 = this.searchResult.body[index2];

      const allPageIds = this.searchResult.body.filter(page => page.areaId === page1.areaId).map(page => page.pageId);

      let idArrayIndex1 = allPageIds.indexOf(page1.pageId);
      let idArrayIndex2 = allPageIds.indexOf(page2.pageId);

      allPageIds[idArrayIndex1] = page2.pageId;
      allPageIds[idArrayIndex2] = page1.pageId;

      this.showTableLoadingAnim();
      api.deviceEnvViewOrderUpdate(page1.areaId, allPageIds)
        .then(({ data }) => {
          if (!statusErrorCodeMsg(data.statusCode, this)) {
            return;
          }
          this.$set(this.searchResult.body, index1, page2);
          this.$set(this.searchResult.body, index2, page1);
        })
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .finally(() => {
          this.hideTableLoadingAnim();
        });
    }
  },
  mounted() {
    let query = this.$getQueryParam(QUERY_SAVE_KEY);
    if(query != null) {
      this.query = query;
      this.doneSearch();
    }
  }
}
</script>

<style scoped>

</style>
